import {
  SearchFilter,
  SearchFilterType,
} from '@aibees/elephant/feature/search-filters/types';

export function useFilterItemsOfType(
  filter: SearchFilter,
  type: SearchFilterType
) {
  return filter.items?.filter((x) => x.type === type);
}
